<template>
	<div class="MainBox" @click.stop="SelectActive(-1,$self)">
    <div class="TableHead">
      <ul class="TableHeadLeft">
        <li class="TableHeadLeftRow btnStyleTwo blueBackColor btnRadius" @click="zsData(true)"><span class="icon iconfont iconicon-test20"></span>添加追溯信息</li>
      </ul>
      <ul class="TableHeadRight">
        <div class="SearchBox">
          <input placeholder="输入产品批次查询" v-model="QueryName" v-on:keyup.13="QueryData" />
          <a class="SearchBtn" @click="QueryData" v-text="$t('c.Common.Search')"></a>
        </div>
      </ul>
      <ul class="clear"></ul>
    </div>

    <div class="TableMain">
      <K-Transition :isLoding="isLoding" :subHint="subHint" v-if="!datas"></K-Transition>
      <table class="table StripeTable" v-else>
        <thead>
          <tr>
            <th>产品批次</th>
            <th>进货批次号</th>
            <th>供应商</th>
            <th>经销商</th>
            <th>追溯码</th>
            <th v-text="$t('c.Common.CreationTime')"></th>
          </tr>
        </thead>
        <tbody class="TRHoverStyle">
          <tr v-for="(item,index) in datas" v-bind:key="index">
            <td v-text="item.batch_name"></td>
            <td v-text="item.stock_batch_no"></td>
            <td v-text="item.supplier_name"></td>
            <td v-text="item.distributor"></td>
            <td v-text="item.batch_code"></td>
            <td v-text="item.created_at"></td>
          </tr>
        </tbody>
      </table>

      <!-- 分页器 -->
      <K-Paging :page="page" :totalPages="totalPages" @ChangePage="ChangePage" @SkipPage="SkipPage"></K-Paging>

    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    <!-- 发货窗口 -->
    <div class="ModalBox" v-if="ModelShow2">
      <div class="ModalMain">
        <div class="ModalMainHead">
          追溯信息
          <span class="icon iconfont iconicon-test29 ModalMainHeadClose feedback"
                @click="zsData(false)"></span>
        </div>
        <div class="ModalMainBox" style="display: flex">
          <ul style="flex: 1;" class="FormStyleTwo">
            <H1>工厂信息</H1>
            <!-- 产品选择 -->
            <li class="FormStyleTwoRow">
              <p class="FormStyleTwoTitle"><i class="redColor">*</i>产品批次</p>
              <p>
              <div class="SelectStyle" @click.stop="SelectActive(0, $self)">
                {{ SelectArr[0].datas[SelectArr[0].ix].name }}
                <ul class="OptionStyleBox" v-if="SelectArr[0].active">
                  <ul class="OptionStyleMain">
                    <li class="OptionStyleRow"
                        :class="{ OptionStyleRowActive: SelectArr[0].ix == index && !SelectArr[0].isHover }"
                        v-for="(item, index) in SelectArr[0].datas" v-bind:key="index" v-text="item.name"
                        @click="SelectData(0, index)"></li>
                    <li class="OptionStyleLoading" @click.stop="SelectArrLoading(0)"
                        v-if="SelectArr[0].totalPages > 1 && SelectArr[0].page < SelectArr[0].totalPages">加载更多</li>
                    <li class="OptionStyleLoading" @click.stop
                        v-if="SelectArr[0].totalPages > 1 && SelectArr[0].page >= SelectArr[0].totalPages">无更多内容</li>
                  </ul>
                </ul>
                <a class="icon iconfont iconicon-test22 OptionStyleIcon"></a>
              </div>
              </p>
            </li>
            <!-- 产品选择 -->
            <!-- 产品选择 -->
            <li class="FormStyleTwoRow">
              <p class="FormStyleTwoTitle"><i class="redColor">*</i>供应商</p>
              <p>
              <div class="SelectStyle" @click.stop="SelectActive(1, $self)">
                {{ SelectArr[1].datas[SelectArr[1].ix].name }}
                <ul class="OptionStyleBox" v-if="SelectArr[1].active">
                  <ul class="OptionStyleMain">
                    <li class="OptionStyleRow"
                        :class="{ OptionStyleRowActive: SelectArr[1].ix == index && !SelectArr[1].isHover }"
                        v-for="(item, index) in SelectArr[1].datas" v-bind:key="index" v-text="item.name"
                        @click="SelectData(1, index)"></li>
                    <li class="OptionStyleLoading" @click.stop="SelectArrLoading(0)"
                        v-if="SelectArr[1].totalPages > 1 && SelectArr[1].page < SelectArr[1].totalPages">加载更多</li>
                    <li class="OptionStyleLoading" @click.stop
                        v-if="SelectArr[1].totalPages > 1 && SelectArr[1].page >= SelectArr[1].totalPages">无更多内容</li>
                  </ul>
                </ul>
                <a class="icon iconfont iconicon-test22 OptionStyleIcon"></a>
              </div>
              </p>
            </li>
            <!-- 产品选择 -->
            <li  class="FormStyleTwoRow">
              <p class="FormStyleTwoTitle"><i>*</i>物料名称</p>
              <p><input placeholder="物料名称" v-model="FormData2.material_name" /></p>
            </li>
            <li  class="FormStyleTwoRow">
              <p class="FormStyleTwoTitle"><i>*</i>进货批次号</p>
              <p><input placeholder="进货批次号" v-model="FormData2.stock_batch_no" /></p>
            </li>
            <li  class="FormStyleTwoRow">
              <p class="FormStyleTwoTitle">进货日期</p>
              <p>
                <el-date-picker type="date" placeholder="进货日期" v-model="FormData2.stock_date" value-format="yyyy-MM-dd"> </el-date-picker>
              </p>
            </li>
            <li  class="FormStyleTwoRow">
              <p class="FormStyleTwoTitle">使用数量</p>
              <p><input placeholder="使用数量" v-model="FormData2.usage_amount" /></p>
            </li>
            <li  class="FormStyleTwoRow">
              <p class="FormStyleTwoTitle">度量单位</p>
              <div class="SelectStyle" @click.stop="SelectActive(6, $self)">
                {{SelectArr[6].datas[SelectArr[6].ix]}}
                <ul class="OptionStyleBox" v-if="SelectArr[6].active">
                  <li class="OptionStyleRow" v-for="(item,index) in SelectArr[6].datas" v-bind:key="index" v-text="item" @click="SelectData(6, index)"></li>
                </ul>
                <a class="icon iconfont iconicon-test22 OptionStyleIcon"></a>
              </div>
            </li>
          </ul>
          <ul style="flex: 1; padding-left: 15px;" class="FormStyleTwo">
            <H1>销售流通信息</H1>
            <!-- 经销商选择 -->
            <li class="FormStyleTwoRow">
              <p class="FormStyleTwoTitle"><i class="redColor">*</i>经销商</p>
              <p>
              <div class="SelectStyle" @click.stop="SelectActive(2, $self)">
                {{ SelectArr[2].datas[SelectArr[2].ix].name }}
                <ul class="OptionStyleBox" v-if="SelectArr[2].active">
                  <ul class="OptionStyleMain">
                    <li class="OptionStyleRow"
                        :class="{ OptionStyleRowActive: SelectArr[2].ix == index && !SelectArr[2].isHover }"
                        v-for="(item, index) in SelectArr[2].datas" v-bind:key="index" v-text="item.name"
                        @click="SelectData(2, index)"></li>
                    <li class="OptionStyleLoading" @click.stop="SelectArrLoading(0)"
                        v-if="SelectArr[2].totalPages > 1 && SelectArr[2].page < SelectArr[2].totalPages">加载更多</li>
                    <li class="OptionStyleLoading" @click.stop
                        v-if="SelectArr[2].totalPages > 1 && SelectArr[2].page >= SelectArr[2].totalPages">无更多内容</li>
                  </ul>
                </ul>
                <a class="icon iconfont iconicon-test22 OptionStyleIcon"></a>
              </div>
              </p>
            </li>
            <!-- 经销商选择 -->
            <li  class="FormStyleTwoRow">
              <p class="FormStyleTwoTitle"><i>*</i>销售日期</p>
              <p>
                <el-date-picker type="date" placeholder="销售日期" v-model="FormData2.sale_time" value-format="yyyy-MM-dd"> </el-date-picker>
              </p>
            </li>
            <li  class="FormStyleTwoRow">
              <p class="FormStyleTwoTitle"><i>*</i>购方客户名称</p>
              <p><input placeholder="购方客户名称" v-model="FormData2.customer" /></p>
            </li>

            <li  class="FormStyleTwoRow">
              <p class="FormStyleTwoTitle"><i>*</i>客户联系方式</p>
              <p><input placeholder="客户联系方式" v-model="FormData2.recipient_contact" /></p>
            </li>
            <li class="FormStyleTwoRow">
              <div style="display: flex">
                <div style="flex: 1;">
                  <p style="width: 150px;" class="FormStyleTwoTitle"><i>*</i>购方省市</p>
                  <p><input style="width: 150px;" disabled="disabled" placeholder="购方省市" v-model="FormData2.province_city" /></p>
                </div>
                <div style="flex: 1;">
                  <p style="width: 300px;" class="FormStyleTwoTitle"><i>*</i>购方详细地址</p>
                  <p><input style="width: 300px;" disabled="disabled" placeholder="购方详细地址" v-model="FormData2.recipient_addr" /></p>
                </div>
              </div>
            </li>
            <li  class="FormStyleTwoRow">
              <p class="FormStyleTwoTitle"><i>*</i>销售订单号</p>
              <p><input placeholder="销售订单号" v-model="FormData2.sell_order_no" /></p>
            </li>
            <li  class="FormStyleTwoRow">
              <p class="FormStyleTwoTitle">销售数量</p>
              <p><input placeholder="销售数量" v-model="FormData2.sell_amount" /></p>
            </li>
          </ul>
          <ul style="flex: 1; padding-left: 15px;" class="FormStyleTwo">
            <li  class="FormStyleTwoRow" style="padding-top: 80px; padding-left: 15px; width: 170px;">
              <p class="FormStyleTwoTitle"><i>*</i>是否公开经销商名称</p>
              <el-radio-group v-model="FormData2.distributor_visible">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </li>
            <li  class="FormStyleTwoRow" style="padding-top: 20px; padding-left: 15px;width: 170px;">
              <p class="FormStyleTwoTitle"><i>*</i>是否公开销售日期</p>
              <el-radio-group v-model="FormData2.sale_time_visible">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </li>
            <li  class="FormStyleTwoRow" style="padding-top: 20px; padding-left: 15px; width: 170px;">
              <p class="FormStyleTwoTitle"><i>*</i>是否公开购方客户名称</p>
              <el-radio-group v-model="FormData2.customer_visible">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </li>
            <li  class="FormStyleTwoRow" style="padding-top: 20px; padding-left: 15px; width: 170px;">
              <p class="FormStyleTwoTitle"><i>*</i>是否公开客户联系方式</p>
              <el-radio-group v-model="FormData2.recipient_contact_visible">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </li>
            <li  class="FormStyleTwoRow" style="padding-top: 20px; padding-left: 15px; width: 170px;">
              <p class="FormStyleTwoTitle"><i>*</i>是否公开地址</p>
              <el-radio-group v-model="FormData2.recipient_addr_visible">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </li>

          </ul>
        </div>
        <div class="ModalMainFoot">
          <!-- <div class="ModalMainFootLeft feedback"><span class="icon iconfont iconicon-test28"></span>{{$t('c.Common.Document')}}</div> -->
          <div class="ModalMainFootRight btnArray">
            <a class="btnStyleTwo btnRadius grayBackColor" @click="zsData(false, 0)"
               v-text="$t('c.Common.Cancel')"></a>
            <a class="btnStyleTwo btnRadius blueBackColor" @click="SubmitFormZs()" v-text="$t('c.Common.Confirm')"></a>
          </div>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
var self;
import axios from 'axios'
import Paging from '@/components/common/Paging.vue'
import Transition from '@/components/common/Transition.vue'
import Loading from '@/components/common/Loading.vue'
import Toast from '@/components/common/Toast.vue'
import Confirm from '@/components/common/Confirm.vue'
export default {
  name: 'BatchManage',
  components: {
    'K-Paging': Paging,
    'K-Transition': Transition,
    'K-Confirm': Confirm,
    'K-Loading': Loading,
    'K-Toast': Toast
  },
  data () {
    return {
      $self:null,
      page:1,
      id:null,
      subHint:'数据加载中...',
      isLoding:true,
      loading:false,
      Toast:{
        state: false,
        type: 0,
        txt: null
      },
      Confirm:{
        state:false,
        txt:null
      },
      totalPages:0,
      datas:null,
      ModelShow:false,
      ModelShow2:false,
      SQueryName: null,
      ModelTwoShow:false,
      FormData2: {
        batch_id: null,
        production_id: null,
        batch_name: null,
        batch_code: null,
        provinceCity: null,
        enterprise_id: 0,
        enterprise_user_id: 0,
        supplier_name: null,
        supplier_visible: 1,
        material_name: null,
        stock_batch_no: null,
        stock_date: null,
        usage_amount: 0,
        measure: null,
        distributor: null,
        distributor_visible: 1,
        sale_time: null,
        sale_time_visible: 1,
        customer: null,
        customer_visible: 1,
        recipient_contact: null,
        recipient_contact_visible: 1,
        recipient_province: null,
        recipient_city: null,
        recipient_addr: null,
        recipient_addr_visible: 1,
        sell_order_no: null,
        sell_amount: 0,
        measure2: null,
      },
      SelectArr:[{
        ix:0,
        active:false,
        page: 1,
        totalPages: 0,
        isHover: false,
        datas:[]
      },{
        ix:0,
        page: 1,
        totalPages: 0,
        isHover: false,
        active:false,
        datas:[]
      },{
        ix:0,
        page: 1,
        totalPages: 0,
        isHover: false,
        active:false,
        datas:[]
      },{
        ix:0,
        active:false,
        datas:["指定失效时间", "长期有效", "详见喷码处"]
      },{
        ix:0,
        active:false,
        datas:["指定生产时间", "详见喷码处"]
      },{
        ix:0,
        active:false,
        datas:["单一码", "数字身份码", "一品一码"]
      },{
        ix:0,
        active:false,
        datas:["千克", "吨", "升", "方", "米", "平方米", "套", "件", "辆", "卷", "张"]
      }],
      batch:{},
      express:{},
      QueryName:null
    }
  },
  created () {
    self = this;
    self.$self = this;
    axios.defaults.headers.common['token'] = localStorage.getItem("wwmxt_Token");
    self.FormData2.enterprise_user_id = self.getSafeCode('enterprise_user_id');
    self.FormData2.enterprise_id = self.getSafeCode('enterprise_id');
    self.FormData2.measure = self.FormData2.measure2 = self.SelectArr[6].datas[0];
    self.QueryData();
    self.init();
  },
  methods: {
    ToastFun (type,txt) {
      self.Toast.state = true;
      self.Toast.type = type;
      self.Toast.txt = txt;
    },
    init() {
      self.GetBatchList();
      self.GetSupList();
      self.GetDealerList();
    },
    SubmitFormZs() {
      const formData = self.FormData2;
      if (!formData.material_name
          || !formData.material_name
          || !formData.stock_batch_no
          || !formData.sale_time
          || !formData.customer
          // || !formData.sale_time_visible
          // || !formData.customer_visible
          // || !formData.recipient_contact_visible
          // || !formData.recipient_addr_visible
          || !formData.recipient_contact
          || !formData.recipient_province
          || !formData.recipient_city
          || !formData.recipient_addr
          || !formData.sell_order_no
      ) {
        return self.ToastFun(2, '请填写必填项');
      }
      self.loading = true;
      axios({
        method: "post",
        url: self.GetServerUrl(1) + "source",
        data: formData
      }).then(function (response) {
        self.QueryData();
        self.ModelShow2 = false;
        self.loading = false;

        //重置表单内容
        self.FormData2.material_name = null;
        self.FormData2.stock_batch_no = null;
        self.FormData2.stock_date = null;
        self.FormData2.usage_amount = 0;
        self.FormData2.sale_time = null;
        self.FormData2.customer = null;
        self.FormData2.recipient_contact = null;
        self.FormData2.recipient_contact_visible = null;
        self.FormData2.recipient_province = null;
        self.FormData2.recipient_city = null;
        self.FormData2.recipient_addr = null;
        self.FormData2.sell_order_no = null;
        self.FormData2.sell_amount = 0;
        self.FormData2.measure = self.FormData2.measure2 = self.SelectArr[6].datas[0];
        self.init();
      }).catch(function (error) {
        self.loading = false;
        self.ToastFun(2, self.ErrorHint(error));  //弹窗提醒
      })

    },
    GetBatchList () {
      axios.post(self.GetServerUrl(1)+"batch_list/1", {no_page: true})
          .then(function (response){
            self.SelectArr[0].datas = response.data.meta;
            if (self.SelectArr[0].datas && self.SelectArr[0].datas[0]) {
              self.FormData2.batch_code = self.SelectArr[0].datas[0]['batch_ext']['batchCode'];
              self.FormData2.production_id = self.SelectArr[0].datas[0]['batch_ext']['production_id'];
              self.FormData2.batch_id = self.SelectArr[0].datas[0]['batch_id'];
              self.FormData2.batch_name = self.SelectArr[0].datas[0]['name'];
            }
          }).catch(function (error){
        self.ToastFun(2, self.ErrorHint(error));
      })
    },
    GetSupList () {
      axios.post(self.GetServerUrl(1)+"sup_list", {no_page: true})
          .then(function (response){
            self.SelectArr[1].datas = response.data.meta;
            if (self.SelectArr[1].datas && self.SelectArr[1].datas[0]) {
              self.FormData2.supplier_name = self.SelectArr[1].datas[0]['name'];
              self.FormData2.supplier_visible = self.SelectArr[1].datas[0]['is_show'];
            }
          }).catch(function (error){
        self.ToastFun(2, self.ErrorHint(error));
      })
    },
    GetDealerList () {
      axios.post(self.GetServerUrl(1)+"dealer_list/1", {no_page: true})
          .then(function (response){
            self.SelectArr[2].datas = response.data.meta;
            if (self.SelectArr[2].datas && self.SelectArr[2].datas[0]) {
                self.FormData2.distributor = self.SelectArr[2].datas[0]['name'];
                self.FormData2.customer = self.SelectArr[2].datas[0]['name'];
                self.FormData2.province_city = self.SelectArr[2].datas[0]['province'] + '/' + self.SelectArr[2].datas[0]['city'];
                self.FormData2.recipient_province = self.SelectArr[2].datas[0]['province'];
                self.FormData2.recipient_city = self.SelectArr[2].datas[0]['city'];
                self.FormData2.recipient_contact = self.SelectArr[2].datas[0]['linkphone'];
                self.FormData2.recipient_addr = self.SelectArr[2].datas[0]['linkaddress'];
            }
          }).catch(function (error){
        self.ToastFun(2, self.ErrorHint(error));
      })
    },
    ChangeToast () {
      self.Toast.state = false;
    },
    ChangePage (data) {  //上下翻页
      if(data.te == 1){
        if(self.page > 1){
          self.page--
        }
      }else{
        if(self.page < self.totalPages){
          self.page++
        }
      }
      self.QueryData();
    },
    SkipPage (data) {  //跳转分页
      self.page = data.ix;
      self.QueryData();
    },
    zsData(status) {
      if (status === true) {
        if (self.SelectArr[0].datas.length === 0) {
          return self.ToastFun(1, "请先添加产品批次！");
        }
        if (self.SelectArr[2].datas.length === 0) {
          return self.ToastFun(1, "请先添加经销商！");
        }
        if (self.SelectArr[1].datas.length === 0) {
          return self.ToastFun(1, "请先添加供应商！");
        }
      }
      self.ModelShow2 = status;
    },
    SelectData (ix,six) {  //选中选择框内容
      self.SelectArr[ix].ix = six;
      self.SelectArr[ix].isHover = false;
      if (ix === 0) {
        self.FormData2.batch_code = self.SelectArr[ix].datas[six]['batch_ext']['batchCode'];
        self.FormData2.production_id = self.SelectArr[ix].datas[six]['batch_ext']['production_id'];
        self.FormData2.batch_id = self.SelectArr[ix].datas[six]['batch_id'];
        self.FormData2.batch_name = self.SelectArr[ix].datas[six]['name'];
      } else if (ix === 1) {
        self.FormData2.supplier_name = self.SelectArr[ix].datas[six]['name'];
        self.FormData2.supplier_visible = self.SelectArr[ix].datas[six]['is_show'];
      } else if (ix === 2) {
        self.FormData2.distributor = self.SelectArr[ix].datas[six]['name'];
        self.FormData2.customer = self.SelectArr[ix].datas[six]['name'];
        self.FormData2.province_city = self.SelectArr[ix].datas[six]['province'] + '/' + self.SelectArr[ix].datas[six]['city'];
        self.FormData2.recipient_province = self.SelectArr[ix].datas[six]['province'];
        self.FormData2.recipient_city = self.SelectArr[ix].datas[six]['city'];
        self.FormData2.recipient_contact = self.SelectArr[ix].datas[six]['linkphone'];
        self.FormData2.recipient_addr = self.SelectArr[ix].datas[six]['linkaddress'];
      } else if (ix === 6) {
        self.FormData2.measure2 = self.SelectArr[ix].datas[six];
        self.FormData2.measure = self.SelectArr[ix].datas[six];
      }
    },
    QueryData () {
      self.isLoding = true;
      axios.post(self.GetServerUrl(1)+"source_list",{page: self.page, name: self.QueryName})
      .then(function (response){
        self.datas = response.data.meta.data;
        self.isLoding = false;
        //总页数
        self.totalPages = response.data.meta.last_page;
      }).catch(function (error){
        self.subHint = self.ErrorHint(error);
        self.isLoding = false;
        self.datas = null;
      })
    }
  }
}
</script>

<style scoped>
  .iconicon-test38{
    font-size:15px !important;
  }

  .FormStyleTwoCustom{
    position: relative;
    margin-bottom: 20px;
  }
  .FormStyleTwoCustom input{
    width: 320px;
  }
  .FormStyleTwoCustomBtnArr{
    position: absolute;
    right:0;
    bottom:2px;
    overflow: hidden;
  }
  .FormStyleTwoCustomBtnArr a{
    width:80px;
    text-align: center;
    display: block;
    float: left;
    height: 35px;
    line-height:35px;
    cursor: pointer;
  }
  .FormStyleTwoUpImg{
    margin-right:10px;
  }
  .FormStyleTwoCenterBtn{
    display: table;
    margin:0 auto;
  }
  .FormStyleTwoCenterBtn a{
    margin-right:5px;
    position: relative;
    top:1px;
  }
</style>
